import { useEffect, useMemo, useRef, useState } from 'react';

import {
    Box,
    Button,
    Card,
    Collapse,
    Checkbox,
    Divider,
    Flex,
    Heading,
    Icon,
    Link,
    Stack,
    Text
} from '@chakra-ui/react';

import { PayPalButtons, PayPalScriptProvider } from "@paypal/react-paypal-js";

import { FiExternalLink } from "react-icons/fi";

export function RegistrationForm({requestActive, eventConfig, regAllowed, regRemaining, buyBadge, recordBadge, registerOnClick}) {
    const regEndRef = useRef(null);

    const [spectatorFlag, setSpectatorFlag] = useState(0);

    const showPaypal = true;

    const badgeCost = spectatorFlag === 0
        ? eventConfig["competitorPrice"]
        : eventConfig["spectatorPrice"];

    const style = {"layout":"vertical"};

    const paypalDisplay = useMemo(()=> {
        return (
            <PayPalScriptProvider 
                options={{
                    clientId: eventConfig["payPalClientId"],
                    components: "buttons",
                    currency: "USD"
                }}
            >
                <PayPalButtons
                    style={style}
                    disabled={requestActive || !regAllowed}
                    forceReRender={[style]}
                    fundingSource={undefined}
                    createOrder={(data, actions) => buyBadge(data, actions, spectatorFlag)}
                    onApprove={(data, actions) => recordBadge(data, actions, spectatorFlag)}
                />
            </PayPalScriptProvider>
        );
    }, [regAllowed, spectatorFlag]);

    try {
        return (
            <>
                <Card maxWidth="1400px" padding={5} mt={4} mb={2}>
                    <Flex flexWrap="wrap" direction="row" justifyContent="space-evenly">
                        <Box alignContent="space-around">
                            <Heading align="center" size="md" mb={4}>
                                There are
                            </Heading>
                            <Heading align="center" size="lg" mb={2}>{regRemaining}</Heading>
                            <Heading align="center" size="md" mb={2}>
                                registration slots left.
                            </Heading>
                        </Box>
                        <Box maxWidth={{base: "300px", xl: "775px"}}>
                            <Text mt={4} mb={4}>
                                Space is limited at this event, so please register as soon as possible.
                            </Text>
                            <Text mb={4}>
                                The cost to attend is <strong>${eventConfig["competitorPrice"]}.00</strong> for both competitors and spectators.
                            </Text>                                    
                        </Box>
                    </Flex>                                             
                </Card>
                <Collapse in={showPaypal} animateOpacity unmountOnExit>
                    <Card maxWidth="1400px" padding={5} mt={4} mb={2}>
                        <Heading align="center" size="xl" mb={4}>${badgeCost}.00 to register</Heading>
                        <Flex mb={4} flexDirection="column" flexFlow="wrap" gap={3} alignItems="center" justifyContent="space-evenly">
                            <Box flex="1 100%" maxWidth={{base: "300px", xl: "650px"}} padding={4} ml="auto" mr="auto" borderRadius={8} bgColor="white">
                                {paypalDisplay}
                            </Box>
                        </Flex>                         
                    </Card>
                </Collapse>
                <div ref={regEndRef} />
            </>
        );
    } catch (e) {
        console.error("RegistrationForm render error: ", e);
    }
}